import { B as BaseLogo } from './BaseLogo-a074ad74.js';
import CapitalOneSvg from './components/CapitalOneSvg.js';
import { j as jsxRuntimeExports } from './jsx-runtime-bd58eb10.js';
import 'styled-components';
import 'styled-system';
import './StyledPath-9c68e4c5.js';
import 'react';

const CapitalOneLogo = _ref => {
  let {
    RenderedLogo = CapitalOneSvg,
    logoProps,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxRuntimeExports.jsx(BaseLogo, {
    "data-qa-id": "capital-one-logo",
    width: [67, null, 112],
    RenderedLogo: RenderedLogo,
    logoProps: logoProps,
    ...props
  });
};

export { CapitalOneLogo as default };
